const {WarehouseProduct, WarehouseStorage, WarehouseProductAdditionalInformation} = require("../../../../../custom_components/js/warehouse/client/WarehouseLevel");

class AddProductToLevelRequest {
    /**
     * @type {string}
     */
    levelId;

    /**
     * @type {string}
     */
    name;

    /**
     * @type {string}
     */
    description;

    /**
     * @type {ProductUnit}
     */
    units;

    /**
     * @type {number}
     */
    currentStock;

    /**
     * @type {number}
     */
    minStock;

    /**
     * @type {number}
     */
    maxStock;

    /**
     * @type {string}
     */
    manufacturerName;

    /**
     * @type {string}
     */
    productNumberManufacturer;

    /**
     * @type {string}
     */
    productNumberCustomer;

    /**
     * @type {string}
     */
    supplierCompanyId;

    /**
     * @type {string}
     */
    supplierArtNo;

    /**
     * @type {number}
     */
    replacementAmount = 0;

    /**
     * @type {number}
     */
    orderItemId;

    constructor(levelId, name, description, supplierCompanyId, supplierArticleNumber, units, currentStock, minStock, maxStock, manufacturerName, manufacturerArticleNumber, articleNumberCustomer, orderItemId) {
        this.levelId = levelId;
        this.name = name;
        this.description = description;
        this.units = units;
        this.currentStock = currentStock;
        this.minStock = minStock;
        this.maxStock = maxStock;

        if(supplierCompanyId && supplierArticleNumber) {
            this.supplierCompanyId = supplierCompanyId;
            this.supplierArtNo = supplierArticleNumber;
        }
        this.manufacturerName = manufacturerName;
        this.productNumberManufacturer = manufacturerArticleNumber;
        this.productNumberCustomer = articleNumberCustomer;
        this.orderItemId = orderItemId;
    }
}

module.exports.AddProductToLevelRequest = AddProductToLevelRequest;